import { render, staticRenderFns } from "./ViewPostActionCreatorReaction.vue?vue&type=template&id=0829b0e0&scoped=true&"
import script from "./ViewPostActionCreatorReaction.vue?vue&type=script&lang=js&"
export * from "./ViewPostActionCreatorReaction.vue?vue&type=script&lang=js&"
import style0 from "./ViewPostActionCreatorReaction.vue?vue&type=style&index=0&id=0829b0e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0829b0e0",
  null
  
)

export default component.exports